// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a3dfea1","455":"849b5097"}[chunkId] + ".chunk.js";
};